import React from 'react'
import { Paper } from '@mui/material'
import './GuidancePanel.scss'

interface GuidancePanelProps {
  title: string
  images: string[]
}

const GuidancePanel: React.FC<GuidancePanelProps> = ({ title, images }) => {
  return (
    <Paper className="guidance-panel">
      <div className="guidance-panel-content">
        {images.map((image, index) => (
          <div key={index} className="guidance-image-container">
            <img
              src={image}
              alt={`${title} - Step ${index + 1}`}
              className="guidance-image"
            />
          </div>
        ))}
      </div>
    </Paper>
  )
}

export default GuidancePanel
